import { useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table } from "antd";
import { billedDataModel } from "./billedDataModel";
import { InvoiceRecord } from "@/views/invoice/manage/InvoiceManageTypes";
import { formatLocalDateTime } from "@/utils/utils";
import BillDetailRender from "@/views/invoice/manage/BillDetailRender";

export function BilledDataTable() {

    const {
        dataSource, pgCfg, loadData, setSelectedRowKeys,
    } = billedDataModel();

    const columns: ColumnsType<InvoiceRecord> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '账单编码',
            dataIndex: 'billCode',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '单据编号',
            dataIndex: 'tradeCode',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (t, r) => BillDetailRender(t, r.branch ?? '', r.tradeCode ?? '', r.tradeTypeCode ?? '')
        },
        {
            title: '发票类型',
            dataIndex: 'invoiceTypeName',
            align: "center",
            width: 80,
            ellipsis: true,
        },
        {
            title: '开票金额',
            dataIndex: 'invoiceAmount',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '发票号码',
            dataIndex: 'invoiceNum',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '开票时间',
            dataIndex: 'invoiceTime',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '创建人',
            dataIndex: 'createUser',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (e => formatLocalDateTime(e))
        }
    ];

    useEffect(() => {
        loadData().then();
    }, [])

    return (
        <Table
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
        />
    )
}

